<template>
  <div class="module-box">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getList"
    >
      <div
        class="mb_news"
        v-for="(item, index) in list"
        :key="index"
        @click.stop="toDetailHandle(item.Url)"
      >
        <div class="mbn_title">{{ item.Title }}</div>
        <div class="overFlowTwo" v-if="item.Summary">{{ item.Summary }}</div>
        <div style="color: #666">
          <span class="iconfont icon-time"></span> {{ item.CreateTime }}
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { List } from "vant";
import { formatTimeDay } from "@/utils/date";
import { newsContentList } from "@/api/lighting";
export default {
  name: "newslist",
  components: {
    "van-list": List,
  },
  data() {
    return {
      list: [],
      pageIndex: 1,
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    toDetailHandle(href) {
      window.location.href = href;
    },

    getList() {
      var that = this;
      var data = {
        AwardYear: that.awardYear,
        CategoryId: 0,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      newsContentList(data)
        .then((res) => {
          var list = res.Data.List;
          list.forEach((item, index) => {
            item.CreateTime = formatTimeDay(item.CreateTime, ".");
          });
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },
  },
  mounted() {
    if (!this.Common._isMobile()) {
      window.location.href = "https://sdj.alighting.com/promotion.html";
    }
  },
};
</script>
<style scoped>
.module-box {
  padding: 3px 12px 28px 12px;
  background: #ffffff;
  border-radius: 5px;
  box-sizing: border-box;
}

.mb_news {
  font-size: 11px;
  line-height: 16px;
  color: #999;
  padding: 17px 0 10px 0;
  border-bottom: 1px solid #e8e8e8;
}

.mb_news .iconfont {
  font-size: 11px;
  padding-right: 3px;
  color: #666;
}

.mb_news > div {
  margin-top: 6px;
}

.mb_news > div.mbn_title {
  font-size: 15px;
  font-weight: bold;
  color: #000733;
  line-height: 20px;
  margin-top: 0px;
}
</style>